import { styled, Skeleton as UiSkeleton } from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)({
    height: 36,
    width: "100%",
})